import { useState } from "react";

export const useMouseOver = () => {
  const [isMouseOver, setIsMouseOver] = useState<boolean>(false);
  const onMouseEnter = () => setIsMouseOver(true);
  const onMouseLeave = () => setIsMouseOver(false);

  return { isMouseOver, onMouseEnter, onMouseLeave };
};
